/** ``slotProps`` for a select whose empty value is a real choice
 *  ("(default)", "No mode (default)"): it shows that option under a
 *  floating label. Without it an unset select showed only its label
 *  inside the field, which read as the value (or as nothing chosen). */
export const SHOW_UNSET_SELECT = {
  select: { displayEmpty: true },
  inputLabel: { shrink: true },
} as const;
